import gql from 'graphql-tag';

export const GET_PAYMENTS = gql`
  query Payments($regionId: ID!, $first: Int, $after: Int, $filter: String) {
    payments(regionId: $regionId, first: $first, after: $after, filter: $filter) {
      totalCount
      payments {
        id
        type
        reference
        memberPK
        amount
        currency
        history
        processed
        createdAt
      }
    }
    clubs(regionId: $regionId) {
      id
      name
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/graphql/index.ts